eshopApp.controller('AlertMessagesController', ['$scope', 'alertMessage', '$timeout', function($scope, alertMessage, $timeout){

	// Types: error, success, warning, info
	// alertMessage.set(message, type, timeout);

	$scope.alertMessages = alertMessage.getMessages;
	$scope.getType = alertMessage.getType;
	$scope.deleteMessage = alertMessage.deleteMessage;

	// Hide (backend) AlertMessages after 3 seconds (Angular AlertMessages hide automatically)
	angular.forEach(angular.element('.alert_timeout'), function(element){
		$timeout(function(){ element.remove() }, 3000);
	});
}]);
